import { render, staticRenderFns } from "./ModattaSideModalNewOfferAudienceByQuestion.vue?vue&type=template&id=dc14e530"
import script from "./ModattaSideModalNewOfferAudienceByQuestion.vue?vue&type=script&lang=js"
export * from "./ModattaSideModalNewOfferAudienceByQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports